import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: any;
  /** The `AWSDate` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 Date](https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates) string. In other words, this scalar type accepts date strings of the form `YYYY-MM-DD`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-05-01**" and "**-9999-01-01**" are both valid dates.  This scalar type can also accept an optional [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators). For example, "**1970-01-01**", "**1970-01-01Z**", "**1970-01-01-07:00**" and "**1970-01-01+05:30**" are all valid dates. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDate: any;
};










export type AccountDetails = {
  __typename?: 'AccountDetails';
  name: Scalars['String'];
  sales?: Maybe<Scalars['Float']>;
  salesDelta?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsDelta?: Maybe<Scalars['Float']>;
  pod?: Maybe<Scalars['Int']>;
  items?: Maybe<Scalars['Int']>;
  storesSelling?: Maybe<Scalars['Int']>;
  potentialStores?: Maybe<Scalars['Int']>;
  voids?: Maybe<Scalars['Int']>;
  opportunityGap?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Int']>;
  dollarSsw?: Maybe<Scalars['Float']>;
  unitSsw?: Maybe<Scalars['Float']>;
};

export type AccountDetailsSeries = {
  __typename?: 'AccountDetailsSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<AccountDetails>>>;
};

export type AccountDistribution = {
  __typename?: 'AccountDistribution';
  rank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  sales?: Maybe<Scalars['Float']>;
  pod?: Maybe<Scalars['Int']>;
  kept?: Maybe<Scalars['Int']>;
  lost?: Maybe<Scalars['Int']>;
  gained?: Maybe<Scalars['Int']>;
};

export type AccountDistributionSeries = {
  __typename?: 'AccountDistributionSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<AccountDistribution>>>;
};

export type AccountPanelDetail = {
  __typename?: 'AccountPanelDetail';
  rank?: Maybe<Scalars['Int']>;
  sales?: Maybe<Scalars['Float']>;
  share?: Maybe<Scalars['Float']>;
};

export type AmountFloat = {
  __typename?: 'AmountFloat';
  amount?: Maybe<Scalars['Float']>;
};

export type AmountFloatSet = {
  __typename?: 'AmountFloatSet';
  amount?: Maybe<Scalars['Float']>;
  amountDelta?: Maybe<Scalars['Float']>;
};



export type BrandResumeDetails = {
  __typename?: 'BrandResumeDetails';
  name?: Maybe<Scalars['String']>;
  sales?: Maybe<Scalars['Float']>;
  salesDelta?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsDelta?: Maybe<Scalars['Float']>;
  pod?: Maybe<Scalars['Int']>;
  podGains?: Maybe<Scalars['Int']>;
  podLosses?: Maybe<Scalars['Int']>;
  storesSelling?: Maybe<Scalars['Int']>;
  voids?: Maybe<Scalars['Int']>;
  opportunityGap?: Maybe<Scalars['Float']>;
};

export type Brands = {
  __typename?: 'Brands';
  client?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
};

export type BrandsFilteringStatus = {
  __typename?: 'BrandsFilteringStatus';
  status: FilteringStatus;
};

export type BrandsList = {
  __typename?: 'BrandsList';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<Brands>>>;
};

export type BrandsResume = {
  __typename?: 'BrandsResume';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<BrandResumeDetails>>>;
};

export type ClientCategory = {
  __typename?: 'ClientCategory';
  category?: Maybe<ClientCategoryEnum>;
};

export enum ClientCategoryEnum {
  Enterprise = 'ENTERPRISE',
  NotEnterprise = 'NOT_ENTERPRISE'
}

export type DatetimeSeriesPoint = {
  __typename?: 'DatetimeSeriesPoint';
  week?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
};

export enum DistributionState {
  Kept = 'kept',
  Lost = 'lost',
  Filled = 'filled',
  NeverSeen = 'neverSeen',
  Unknown = 'unknown'
}

export enum ExportType {
  Pdf = 'PDF',
  Xlsx = 'XLSX'
}

export enum FilteringStatus {
  Filterable = 'FILTERABLE',
  NotFilterable = 'NOT_FILTERABLE'
}

export type GlobalFilterInput = {
  weeks: Scalars['Int'];
  endWeek: Scalars['String'];
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand?: Maybe<Scalars['String']>;
};

export type ItemGroupDetail = {
  __typename?: 'ItemGroupDetail';
  sales: Scalars['Float'];
  salesDelta: Scalars['Float'];
  units: Scalars['Float'];
  unitsDelta: Scalars['Float'];
  arp: Scalars['Float'];
  pod: Scalars['Int'];
  podDelta: Scalars['Float'];
  ups: Scalars['Float'];
  upcCount: Scalars['Int'];
};

export type ItemOpportunityDetail = {
  __typename?: 'ItemOpportunityDetail';
  rank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  sales?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Int']>;
  voids?: Maybe<Scalars['Int']>;
  opportunityGap?: Maybe<Scalars['Float']>;
};

export type ItemPanelDetail = {
  __typename?: 'ItemPanelDetail';
  rank?: Maybe<Scalars['Int']>;
  sales?: Maybe<Scalars['Float']>;
  share?: Maybe<Scalars['Float']>;
  storeSalesPct?: Maybe<Scalars['Float']>;
};

export type ItemsDetails = {
  __typename?: 'ItemsDetails';
  rank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  upc?: Maybe<Scalars['String']>;
  sales?: Maybe<Scalars['Float']>;
  salesDelta?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsDelta?: Maybe<Scalars['Float']>;
  arp?: Maybe<Scalars['Float']>;
  pod?: Maybe<Scalars['Int']>;
  podDelta?: Maybe<Scalars['Float']>;
  unitsSsw?: Maybe<Scalars['Float']>;
  dollarSsw?: Maybe<Scalars['Float']>;
  voids?: Maybe<Scalars['Int']>;
  opportunityGap?: Maybe<Scalars['Float']>;
};

export type ItemsDetailsSeries = {
  __typename?: 'ItemsDetailsSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<ItemsDetails>>>;
};

export type ItemsDistribution = {
  __typename?: 'ItemsDistribution';
  rank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  sales?: Maybe<Scalars['Float']>;
  pod?: Maybe<Scalars['Int']>;
  kept?: Maybe<Scalars['Int']>;
  lost?: Maybe<Scalars['Int']>;
  gained?: Maybe<Scalars['Int']>;
};

export type ItemsDistributionSeries = {
  __typename?: 'ItemsDistributionSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<ItemsDistribution>>>;
};

export type LabeledAmountSeries = {
  __typename?: 'LabeledAmountSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
};

export type LabelSeriesPoint = {
  __typename?: 'LabelSeriesPoint';
  label?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
};

export type Page = {
  __typename?: 'Page';
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
  currentPage: Scalars['Int'];
};

export type PageableInput = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortedBy?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<SortDirection>;
  search?: Maybe<Scalars['String']>;
  searchBy?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PortfolioInput = {
  clients?: Maybe<Array<Maybe<Scalars['String']>>>;
  weeks: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  salesKPI?: Maybe<AmountFloatSet>;
  unitsKPI?: Maybe<AmountFloatSet>;
  podKPI?: Maybe<AmountFloatSet>;
  storesSellingKPI?: Maybe<AmountFloatSet>;
  unitsStoresSellingKPI?: Maybe<AmountFloatSet>;
  storesSellingPercentageKPI?: Maybe<AmountFloatSet>;
  opportunityGapKPI?: Maybe<AmountFloatSet>;
  salesTrendSeries?: Maybe<Array<Maybe<DatetimeSeriesPoint>>>;
  unitsTrendSeries?: Maybe<Array<Maybe<DatetimeSeriesPoint>>>;
  locationsTrendSeries?: Maybe<Array<Maybe<DatetimeSeriesPoint>>>;
  accountSalesShareSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  accountUnitsShareSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  distributionGainsSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  distributionLossesSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  accountPodGainsSeries?: Maybe<LabeledAmountSeries>;
  accountPodLossesSeries?: Maybe<LabeledAmountSeries>;
  accountOpportunitiesSalesSeries?: Maybe<LabeledAmountSeries>;
  accountDetailsSeries?: Maybe<AccountDetailsSeries>;
  storeDetailsSeries?: Maybe<StoreDetailsSeries>;
  itemsPodGainsSeries?: Maybe<LabeledAmountSeries>;
  itemsPodLossesSeries?: Maybe<LabeledAmountSeries>;
  itemsOpportunitiesSalesSeries?: Maybe<LabeledAmountSeries>;
  itemsDetailsSeries?: Maybe<ItemsDetailsSeries>;
  itemsSalesShareSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  itemsUnitsShareSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  distributionKeptKPI?: Maybe<AmountFloat>;
  distributionLostKPI?: Maybe<AmountFloat>;
  distributionVoidKPI?: Maybe<AmountFloat>;
  distributionFilledKPI?: Maybe<AmountFloat>;
  voidAccountsDetailsSeries?: Maybe<VoidDetailsSeries>;
  voidStoresDetailsSeries?: Maybe<VoidDetailsSeries>;
  voidItemsDetailsSeries?: Maybe<VoidItemsSeries>;
  opportunityVoidsSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  opportunitySalesSeries?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  export?: Maybe<Scalars['Boolean']>;
  storeSalesTrendSeries: StoreSalesTrendSeries;
  itemGroupDetail?: Maybe<ItemGroupDetail>;
  storeGroupDetail?: Maybe<StoreGroupDetail>;
  salesKPIPortfolio?: Maybe<AmountFloatSet>;
  unitsKPIPortfolio?: Maybe<AmountFloatSet>;
  podKPIPortfolio?: Maybe<AmountFloatSet>;
  storesSellingKPIPortfolio?: Maybe<AmountFloatSet>;
  storesSellingPercentageKPIPortfolio?: Maybe<AmountFloatSet>;
  opportunityGapKPIPortfolio?: Maybe<AmountFloatSet>;
  salesTrendSeriesPortfolio?: Maybe<Array<Maybe<DatetimeSeriesPoint>>>;
  unitsTrendSeriesPortfolio?: Maybe<Array<Maybe<DatetimeSeriesPoint>>>;
  locationsTrendSeriesPortfolio?: Maybe<Array<Maybe<DatetimeSeriesPoint>>>;
  accountSalesShareSeriesPortfolio?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  accountUnitsShareSeriesPortfolio?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  distributionGainsSeriesPortfolio?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  distributionLossesSeriesPortfolio?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  itemsSalesShareSeriesPortfolio?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  itemsUnitsShareSeriesPortfolio?: Maybe<Array<Maybe<LabelSeriesPoint>>>;
  accountPodGainsSeriesPortfolio?: Maybe<LabeledAmountSeries>;
  accountPodLossesSeriesPortfolio?: Maybe<LabeledAmountSeries>;
  accountOpportunitiesSalesSeriesPortfolio?: Maybe<LabeledAmountSeries>;
  brandResumePortfolio?: Maybe<BrandsResume>;
  getBrandListByClient?: Maybe<BrandsList>;
  getBrandsFilteringStatus?: Maybe<BrandsFilteringStatus>;
  getClientCategory?: Maybe<ClientCategory>;
};


export type QuerySalesKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryUnitsKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryPodKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryStoresSellingKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryUnitsStoresSellingKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryStoresSellingPercentageKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryOpportunityGapKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QuerySalesTrendSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryUnitsTrendSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryLocationsTrendSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryAccountSalesShareSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryAccountUnitsShareSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryDistributionGainsSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryDistributionLossesSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryAccountPodGainsSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryAccountPodLossesSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryAccountOpportunitiesSalesSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryAccountDetailsSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
  tableFilter?: Maybe<Array<Maybe<RangeFilter>>>;
};


export type QueryStoreDetailsSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
  tableFilter?: Maybe<Array<Maybe<RangeFilter>>>;
};


export type QueryItemsPodGainsSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryItemsPodLossesSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryItemsOpportunitiesSalesSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryItemsDetailsSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
  tableFilter?: Maybe<Array<Maybe<RangeFilter>>>;
};


export type QueryItemsSalesShareSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
};


export type QueryItemsUnitsShareSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
};


export type QueryDistributionKeptKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryDistributionLostKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryDistributionVoidKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryDistributionFilledKpiArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryVoidAccountsDetailsSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryVoidStoresDetailsSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryVoidItemsDetailsSeriesArgs = {
  client: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryOpportunityVoidsSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryOpportunitySalesSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryExportArgs = {
  template: Scalars['String'];
  client: Scalars['String'];
  exportType: ExportType;
  recipients: Array<Maybe<Scalars['AWSEmail']>>;
  globalFilter: GlobalFilterInput;
};


export type QueryStoreSalesTrendSeriesArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
  pageable: PageableInput;
};


export type QueryItemGroupDetailArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QueryStoreGroupDetailArgs = {
  client: Scalars['String'];
  globalFilter: GlobalFilterInput;
};


export type QuerySalesKpiPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryUnitsKpiPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryPodKpiPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryStoresSellingKpiPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryStoresSellingPercentageKpiPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryOpportunityGapKpiPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QuerySalesTrendSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryUnitsTrendSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryLocationsTrendSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryAccountSalesShareSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryAccountUnitsShareSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryDistributionGainsSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryDistributionLossesSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryItemsSalesShareSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryItemsUnitsShareSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
};


export type QueryAccountPodGainsSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
  pageable: PageableInput;
};


export type QueryAccountPodLossesSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
  pageable: PageableInput;
};


export type QueryAccountOpportunitiesSalesSeriesPortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
  pageable: PageableInput;
};


export type QueryBrandResumePortfolioArgs = {
  client: Scalars['String'];
  globalFilter: PortfolioInput;
  pageable: PageableInput;
  tableFilter?: Maybe<Array<Maybe<RangeFilter>>>;
};


export type QueryGetBrandListByClientArgs = {
  client: Scalars['String'];
  globalFilter?: Maybe<PortfolioInput>;
  pageable: PageableInput;
};


export type QueryGetBrandsFilteringStatusArgs = {
  client: Scalars['String'];
  brandId: Scalars['String'];
  globalFilter?: Maybe<PortfolioInput>;
};


export type QueryGetClientCategoryArgs = {
  client: Scalars['String'];
};

export type RangeFilter = {
  fieldName: Scalars['String'];
  filters?: Maybe<RangeFilterOptions>;
  decimals?: Maybe<Scalars['Int']>;
};

export type RangeFilterOptions = {
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  eq?: Maybe<Scalars['Float']>;
  neq?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StoreDetails = {
  __typename?: 'StoreDetails';
  name: Scalars['String'];
  sales?: Maybe<Scalars['Float']>;
  salesDelta?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsDelta?: Maybe<Scalars['Float']>;
  items?: Maybe<Scalars['Int']>;
  voids?: Maybe<Scalars['Int']>;
  topOpportunity?: Maybe<Scalars['String']>;
  storeTag?: Maybe<Scalars['String']>;
};

export type StoreDetailsSeries = {
  __typename?: 'StoreDetailsSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<StoreDetails>>>;
};

export type StoreGroupDetail = {
  __typename?: 'StoreGroupDetail';
  sales: Scalars['Float'];
  salesDelta: Scalars['Float'];
  units: Scalars['Float'];
  unitsDelta: Scalars['Float'];
  pod: Scalars['Int'];
  items: Scalars['Int'];
  stores: Scalars['Int'];
  storesSelling: Scalars['Int'];
  potentialStores: Scalars['Int'];
  voids: Scalars['Int'];
  opportunityGap: Scalars['Float'];
};

export type StoreGroupsDetails = {
  __typename?: 'StoreGroupsDetails';
  storeCount: Scalars['Int'];
  sales?: Maybe<Scalars['Float']>;
  salesDelta?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsDelta?: Maybe<Scalars['Float']>;
  pod?: Maybe<Scalars['Int']>;
  items?: Maybe<Scalars['Int']>;
  storesSelling?: Maybe<Scalars['Int']>;
  potentialStores?: Maybe<Scalars['Int']>;
  voids?: Maybe<Scalars['Int']>;
  opportunityGap?: Maybe<Scalars['Float']>;
};

export type StoreGroupsDetailsSeries = {
  __typename?: 'StoreGroupsDetailsSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<StoreGroupsDetails>>>;
};

export type StorePanelDetail = {
  __typename?: 'StorePanelDetail';
  rank?: Maybe<Scalars['Int']>;
  sales?: Maybe<Scalars['Float']>;
  share?: Maybe<Scalars['Float']>;
};

export type StoreSalesTrendPoint = {
  __typename?: 'StoreSalesTrendPoint';
  week: Scalars['AWSDate'];
  account: Scalars['String'];
  store: Scalars['String'];
  address: Scalars['String'];
  upc: Scalars['String'];
  item: Scalars['String'];
  sales: Scalars['Float'];
  units: Scalars['Float'];
};

export type StoreSalesTrendSeries = {
  __typename?: 'StoreSalesTrendSeries';
  data: Array<Maybe<StoreSalesTrendPoint>>;
  page: Page;
};

export type VoidDetailsSeries = {
  __typename?: 'VoidDetailsSeries';
  page?: Maybe<Page>;
  itemHeaders: Array<Maybe<VoidItemHeader>>;
  data?: Maybe<Array<Maybe<VoidTableDetails>>>;
};

export type VoidItemDetails = {
  __typename?: 'VoidItemDetails';
  voids: Scalars['Int'];
  upc: Scalars['String'];
  description: Scalars['String'];
  distributionState?: Maybe<DistributionState>;
  sales?: Maybe<Scalars['Float']>;
  recentSaleDate?: Maybe<Scalars['String']>;
};

export type VoidItemHeader = {
  __typename?: 'VoidItemHeader';
  voids?: Maybe<Scalars['Int']>;
  upc: Scalars['String'];
  description: Scalars['String'];
  sales: Scalars['Float'];
  recentSaleDate?: Maybe<Scalars['String']>;
};

export type VoidItemsSeries = {
  __typename?: 'VoidItemsSeries';
  page?: Maybe<Page>;
  data?: Maybe<Array<Maybe<VoidItemDetails>>>;
};

export type VoidTableDetails = {
  __typename?: 'VoidTableDetails';
  name: Scalars['String'];
  voids: Scalars['Int'];
  sales: Scalars['Float'];
  rank?: Maybe<Scalars['Int']>;
  items: Array<Maybe<VoidItemDetails>>;
  storeTag?: Maybe<Scalars['String']>;
};

export type GetBrandsFilteringStatusQueryVariables = Exact<{
  client: Scalars['String'];
  brandId: Scalars['String'];
  globalFilter?: Maybe<PortfolioInput>;
}>;


export type GetBrandsFilteringStatusQuery = (
  { __typename?: 'Query' }
  & { getBrandsFilteringStatus?: Maybe<(
    { __typename?: 'BrandsFilteringStatus' }
    & Pick<BrandsFilteringStatus, 'status'>
  )> }
);

export type BrandResumePortfolioQueryVariables = Exact<{
  clientID: Scalars['String'];
  globalFilter: PortfolioInput;
  pageable: PageableInput;
  tableFilter?: Maybe<Array<Maybe<RangeFilter>> | Maybe<RangeFilter>>;
}>;


export type BrandResumePortfolioQuery = (
  { __typename?: 'Query' }
  & { brandResumePortfolio?: Maybe<(
    { __typename?: 'BrandsResume' }
    & { page?: Maybe<(
      { __typename?: 'Page' }
      & Pick<Page, 'totalItems' | 'totalPages' | 'currentPage'>
    )>, data?: Maybe<Array<Maybe<(
      { __typename?: 'BrandResumeDetails' }
      & Pick<BrandResumeDetails, 'name' | 'sales' | 'salesDelta' | 'units' | 'unitsDelta' | 'pod' | 'podGains' | 'podLosses' | 'storesSelling' | 'voids' | 'opportunityGap'>
    )>>> }
  )> }
);

export type DistributionGainsSeriesQueryVariables = Exact<{
  clientID: Scalars['String'];
  globalFilter: GlobalFilterInput;
}>;


export type DistributionGainsSeriesQuery = (
  { __typename?: 'Query' }
  & { distributionGainsSeries?: Maybe<Array<Maybe<(
    { __typename?: 'LabelSeriesPoint' }
    & Pick<LabelSeriesPoint, 'label' | 'amount'>
  )>>> }
);

export type DistributionGainsSeriesPortfolioQueryVariables = Exact<{
  clientID: Scalars['String'];
  globalFilter: PortfolioInput;
}>;


export type DistributionGainsSeriesPortfolioQuery = (
  { __typename?: 'Query' }
  & { distributionGainsSeriesPortfolio?: Maybe<Array<Maybe<(
    { __typename?: 'LabelSeriesPoint' }
    & Pick<LabelSeriesPoint, 'label' | 'amount'>
  )>>> }
);

export type DistributionLossesSeriesQueryVariables = Exact<{
  clientID: Scalars['String'];
  globalFilter: GlobalFilterInput;
}>;


export type DistributionLossesSeriesQuery = (
  { __typename?: 'Query' }
  & { distributionLossesSeries?: Maybe<Array<Maybe<(
    { __typename?: 'LabelSeriesPoint' }
    & Pick<LabelSeriesPoint, 'label' | 'amount'>
  )>>> }
);

export type DistributionLossesSeriesPortfolioQueryVariables = Exact<{
  clientID: Scalars['String'];
  globalFilter: PortfolioInput;
}>;


export type DistributionLossesSeriesPortfolioQuery = (
  { __typename?: 'Query' }
  & { distributionLossesSeriesPortfolio?: Maybe<Array<Maybe<(
    { __typename?: 'LabelSeriesPoint' }
    & Pick<LabelSeriesPoint, 'label' | 'amount'>
  )>>> }
);


export const GetBrandsFilteringStatusDocument = gql`
    query getBrandsFilteringStatus($client: String!, $brandId: String!, $globalFilter: PortfolioInput) {
  getBrandsFilteringStatus(client: $client, brandId: $brandId, globalFilter: $globalFilter) {
    status
  }
}
    `;
export type GetBrandsFilteringStatusQueryResult = Apollo.QueryResult<GetBrandsFilteringStatusQuery, GetBrandsFilteringStatusQueryVariables>;
export const BrandResumePortfolioDocument = gql`
    query BrandResumePortfolio($clientID: String!, $globalFilter: PortfolioInput!, $pageable: PageableInput!, $tableFilter: [RangeFilter]) {
  brandResumePortfolio(client: $clientID, globalFilter: $globalFilter, pageable: $pageable, tableFilter: $tableFilter) {
    page {
      totalItems
      totalPages
      currentPage
    }
    data {
      name
      sales
      salesDelta
      units
      unitsDelta
      pod
      podGains
      podLosses
      storesSelling
      voids
      opportunityGap
    }
  }
}
    `;
export type BrandResumePortfolioQueryResult = Apollo.QueryResult<BrandResumePortfolioQuery, BrandResumePortfolioQueryVariables>;
export const DistributionGainsSeriesDocument = gql`
    query distributionGainsSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
  distributionGainsSeries(client: $clientID, globalFilter: $globalFilter) {
    label
    amount
  }
}
    `;
export type DistributionGainsSeriesQueryResult = Apollo.QueryResult<DistributionGainsSeriesQuery, DistributionGainsSeriesQueryVariables>;
export const DistributionGainsSeriesPortfolioDocument = gql`
    query distributionGainsSeriesPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
  distributionGainsSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
    label
    amount
  }
}
    `;
export type DistributionGainsSeriesPortfolioQueryResult = Apollo.QueryResult<DistributionGainsSeriesPortfolioQuery, DistributionGainsSeriesPortfolioQueryVariables>;
export const DistributionLossesSeriesDocument = gql`
    query distributionLossesSeries($clientID: String!, $globalFilter: GlobalFilterInput!) {
  distributionLossesSeries(client: $clientID, globalFilter: $globalFilter) {
    label
    amount
  }
}
    `;
export type DistributionLossesSeriesQueryResult = Apollo.QueryResult<DistributionLossesSeriesQuery, DistributionLossesSeriesQueryVariables>;
export const DistributionLossesSeriesPortfolioDocument = gql`
    query distributionLossesSeriesPortfolio($clientID: String!, $globalFilter: PortfolioInput!) {
  distributionLossesSeriesPortfolio(client: $clientID, globalFilter: $globalFilter) {
    label
    amount
  }
}
    `;
export type DistributionLossesSeriesPortfolioQueryResult = Apollo.QueryResult<DistributionLossesSeriesPortfolioQuery, DistributionLossesSeriesPortfolioQueryVariables>;